import {
    useEffect,
    useState,
} from 'react';

import {Certificate} from '../types';

// FNP-1193 — selection, module-scoped for the same reason the keyword and the
// filter are: the toolbar that acts on a selection and the table that makes one
// are not siblings that can share a useState. `SimplePageLayout` renders the
// header as a `pageHeader` prop and the table as its child.
//
// ⚠️ THE FULL CERTIFICATE IS KEPT, NOT A SET OF IDS.
//
// The delete confirmation names the certificate and lists what it covers, and
// the in-use refusal it may come back with needs the covered names to explain
// what would have gone offline. Keeping ids would mean looking each one up
// again to say anything useful.

let globalSelection: Certificate[] = [];
const selectionListeners: Set<(selected: Certificate[]) => void> = new Set();

const notifySelectionChange = (selected: Certificate[]) => {
    globalSelection = selected;
    selectionListeners.forEach(listener => listener(selected));
};

// Test-only reset. The store outlives a component tree by design, which means
// it also outlives a test case — without this, a selection made in one test
// leaks into the next.
export const resetCertificatesSelection = () => {
    globalSelection = [];
    selectionListeners.clear();
};

export const useCertificatesSelection = () => {

    const [selectedRecords, setSelected] = useState<Certificate[]>(globalSelection);

    useEffect(() => {
        const listener = (selected: Certificate[]) => {
            setSelected(selected);
        };
        selectionListeners.add(listener);
        // A consumer mounting after a selection was made must not start empty.
        setSelected(globalSelection);
        return () => {
            selectionListeners.delete(listener);
        };
    }, []);

    return {
        selectedRecords,
        setSelectedRecords: (selected: Certificate[]) => notifySelectionChange(selected),
        clearSelection: () => notifySelectionChange([]),
    };
};
